import { CharterStatus } from '@ankor-io/common/types/charter'

import { Input } from '@/ui-components/Input'
import { Select } from '@/ui-components/Select'

export type CharterFiltersState = {
  status: CharterStatus | ''
  startDate: string
  endDate: string
}

type CharterFiltersProps = {
  filters: CharterFiltersState
  onFilterChange: (key: string, value: string) => void
}

export const CharterFilters = ({ filters, onFilterChange }: CharterFiltersProps) => {
  return (
    <div className="flex items-center flex-col md:flex-row gap-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      {/* Charter Status */}
      <div className="w-full md:w-auto flex flex-col gap-1">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Charter Status</label>
        <Select
          value={filters.status}
          onChange={(e) => onFilterChange('status', e.target.value)}
          className="cursor-pointer"
        >
          <option value="">All Statuses</option>
          <option value={CharterStatus.UPCOMING}>Upcoming</option>
          <option value={CharterStatus.IN_PROGRESS}>In Progress</option>
          <option value={CharterStatus.COMPLETED}>Completed</option>
          <option value={CharterStatus.CANCELLED}>Cancelled</option>
        </Select>
      </div>

      {/* Start Date */}
      <div className="w-full md:w-auto flex flex-col gap-1">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Start Date</label>
        <Input
          type="date"
          value={filters.startDate}
          onChange={(e) => onFilterChange('startDate', e.target.value)}
        />
      </div>

      {/* End Date */}
      <div className="w-full md:w-auto flex flex-col gap-1">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">End Date</label>
        <Input
          type="date"
          value={filters.endDate}
          onChange={(e) => onFilterChange('endDate', e.target.value)}
        />
      </div>
    </div>
  )
}
